module.exports = __webpack_public_path__ + "img/photo3.d09618ca.jpg";